import Modal from './modal.js';

if( document.getElementsByClassName('launch-modal').length > 0 ){
  [...document.getElementsByClassName('launch-modal')].forEach( element => {
    //get content
    let content = element.getElementsByClassName('modal-content')[0];
    let modal = new Modal( content );
    //add listener
    element.addEventListener('click', e => modal.showModal() );
  })
}
